import classnames from 'classnames';
import _ from 'lodash';
import React from 'react';

import { format } from 'src/lib/format';

import { TraceTreeNode } from '../TraceTree';

import { leftMarginForDepth } from './layoutHelpers';

const TraceNodeErrors = ({
  className,
  node,
}: {
  className?: string;
  node: TraceTreeNode;
}) => {
  return (
    <>
      {node.errors.length > 0 && (
        <div
          className={classnames(
            'relative z-10 flex rounded-sm bg-error px-6 py-2 text-xs',
            className,
          )}
        >
          <div className="min-w-0 text-error">
            {node.errors.length} {format.pluralize(node.errors.length, 'error')}{' '}
            {node.path.length > 0 ? (
              <>
                while executing path:{' '}
                {node.path.map((n, i) => (
                  // eslint-disable-next-line react/no-array-index-key
                  <React.Fragment key={i}>
                    {n.name}
                    {i < node.path.length - 1 ? '.' : ''}
                    <wbr />
                  </React.Fragment>
                ))}
              </>
            ) : (
              'outside the GraphQL context'
            )}
            <table className="mt-4">
              {node.errors.map(({ message, locations }, i) => {
                const location = locations[0];
                const locationInfo = location
                  ? `[line: ${location.line}, column: ${location.column}] `
                  : '[location unavailable] ';
                return (
                  <tbody
                    key={
                      `error-${i}` /* eslint-disable-line react/no-array-index-key */
                    }
                  >
                    <tr className="border-l-2 border-warning">
                      <td className="pl-2 pr-3 font-semibold">Location</td>
                      <td>{locationInfo}</td>
                    </tr>
                    <tr className="mt-1 border-l-2 border-warning">
                      <td className="pl-2 pr-3 font-semibold">Message</td>
                      <td>{message}</td>
                    </tr>
                  </tbody>
                );
              })}
            </table>
          </div>
        </div>
      )}
    </>
  );
};

export const TraceNodeDrawer = ({
  className,
  node,
  depth,
  isOpen,
  showBorder,
}: {
  className?: string;
  node: TraceTreeNode;
  depth: number;
  isOpen: boolean;
  showBorder: boolean;
}) => {
  return (
    <>
      {isOpen && (
        <div
          style={{ gridColumn: '1 / span 4' }}
          className={classnames(
            'relative z-20 overflow-hidden font-mono text-sm',
            className,
          )}
        >
          <TraceNodeErrors node={node} />
          {node.children.length > 0 && (
            <div
              className={classnames(
                'absolute inset-y-0 ml-3 h-full w-2 flex-none border-silver-darker',
                { 'border-l': showBorder },
              )}
              style={{ left: leftMarginForDepth(depth, 0.25) }}
            />
          )}
        </div>
      )}
    </>
  );
};
